module.exports = __webpack_public_path__ + "static/media/sf-trial-3-wrong.89e52c93.mp3";